import { create } from "zustand"
import type { SimulatorService } from "@/features/drafting/simulatorHandoff"

type NavMode = "labeled" | "rail"

interface ShellState {
  simulatorService: SimulatorService | null
  navMode: NavMode
  openSimulator: (service: SimulatorService) => void
  closeSimulator: () => void
  /** Retained for direct OrderTypePicker tests; the shell no longer mounts it. */
  closePicker: () => void
  toggleNav: () => void
  /** Programmatic set — used to rail the nav while a draft generates so the
   * order gets the full width, and to restore the officer's choice after. */
  setNavMode: (mode: NavMode) => void
}

const initialNav: NavMode =
  typeof document !== "undefined" && document.documentElement.getAttribute("data-nav") === "rail"
    ? "rail"
    : "labeled"

export const useShellStore = create<ShellState>((set) => ({
  simulatorService: null,
  navMode: initialNav,
  openSimulator: (service) => set({ simulatorService: service }),
  closeSimulator: () => set({ simulatorService: null }),
  closePicker: () => undefined,
  toggleNav: () => set((s) => ({ navMode: s.navMode === "rail" ? "labeled" : "rail" })),
  setNavMode: (mode) => set({ navMode: mode }),
}))
